import Skeleton from 'react-loading-skeleton';

import Text from 'components/common/Text';
import CutOffDateAndTime from 'components/signUpFunnel/thankYou/CutOffDateAndTime';
import ThankYouButton from 'components/signUpFunnel/thankYou/ThankYouButton';
import styles from 'styles/components/signUpFunnel/thankYou/NextSteps';

const NextSteps = ({ basket, firstDeliveryDateFormatted, onClick, postSignupUrl, user }) => {
  const NextStepsContent = () => {
    return (
      <>
        <div className="-mx-6 flex flex-col border-b border-solid border-charcoal-60 px-6 pb-6">
          <Text brandStylesOverrides="h5 text-secondary">Your first box will be delivered on</Text>
          <Text brandStylesOverrides="h3 font-medium text-primary" className="mb-4">
            {basket ? firstDeliveryDateFormatted : <Skeleton className={styles.skeleton150} />}
          </Text>
          <div className="flex items-center">
            <CutOffDateAndTime />
          </div>
          <Text brandStylesOverrides="textSm text-tempo-black-100" className="mt-1">
            Heads up! You'll receive our pre-selected meals if you don't make changes before that
            date.
          </Text>
          <div className="mt-2">
            <ThankYouButton
              onClick={onClick}
              postSignupUrl={postSignupUrl}
              user={user}
              variant="primary"
              buttonStyles="w-full"
            />
          </div>
        </div>
      </>
    );
  };

  return <NextStepsContent />;
};

NextSteps.propTypes = {
  basket: PropTypes.object.isRequired,
  firstDeliveryDateFormatted: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  postSignupUrl: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
};

export default NextSteps;
